var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeedCollection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 54.281 54.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_11",
    transform: "translate(-0.827 -0.84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28302",
    "data-name": "Path 28302",
    d: "M14.018,30.05A22.128,22.128,0,0,1,5.7,32.592a22.171,22.171,0,0,1,2.541-8.321,1.623,1.623,0,1,0-2.815-1.616A26.122,26.122,0,0,0,2.33,34.337,1.623,1.623,0,0,0,3.953,35.96a26.122,26.122,0,0,0,11.683-3.094,1.624,1.624,0,0,0-1.617-2.816Z",
    transform: "translate(0.996 16.663)",
    fill: "#96006b",
    stroke: "#96006b",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28303",
    "data-name": "Path 28303",
    d: "M54.858,5.03a3.837,3.837,0,0,0-1.132-2.813A4.1,4.1,0,0,0,50.918,1.09,44.112,44.112,0,0,0,22.836,12.758c-2.045-.8-5.126-1.976-7.465-1.675-3.44.442-8.523,5.123-13.5,10.117a2.668,2.668,0,0,0,1.08,4.423l7.916,2.542c-.6,1.089-1.185,2.2-1.753,3.379a3.868,3.868,0,0,0,.754,4.416L19.987,46.082a3.87,3.87,0,0,0,4.418.756c1.176-.568,2.29-1.156,3.375-1.751L30.324,53a2.656,2.656,0,0,0,1.917,1.783,2.73,2.73,0,0,0,.637.076,2.642,2.642,0,0,0,1.872-.779c4.995-4.978,9.676-10.06,10.116-13.5.3-2.36-.88-5.424-1.675-7.469A44.123,44.123,0,0,0,54.858,5.03ZM4.837,22.823c2.642-2.631,8.379-8.19,10.947-8.52a11.523,11.523,0,0,1,4.461.947,58.155,58.155,0,0,0-7.712,10.043ZM22.993,43.914a.631.631,0,0,1-.71-.126L12.159,33.665a.629.629,0,0,1-.124-.71C24.641,6.844,45.03,4.449,50.981,4.337H51a.6.6,0,0,1,.438.179.623.623,0,0,1,.182.454c-.115,5.95-2.512,26.34-28.623,38.944Zm18.653-3.747c-.33,2.566-5.889,8.305-8.52,10.945l-2.474-7.694A58.056,58.056,0,0,0,40.7,35.7,11.433,11.433,0,0,1,41.646,40.168Z",
    transform: "translate(0 0)",
    fill: "#ff0185",
    stroke: "#ff0185",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28304",
    "data-name": "Path 28304",
    d: "M29.307,18.363a6.821,6.821,0,0,0,0-9.632,6.978,6.978,0,0,0-9.632,0,6.811,6.811,0,0,0,9.632,9.632Zm-2.3-2.3a3.644,3.644,0,0,1-5.04,0,3.564,3.564,0,1,1,5.04,0Z",
    transform: "translate(13.324 4.588)",
    fill: "#96006b",
    stroke: "#96006b",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedCollection);
export default __webpack_public_path__ + "static/media/SpeedCollection.71a040bd7942ae8c01e54fafb7986a89.svg";
export { ForwardRef as ReactComponent };